import {
  SET_USER,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED, SET_USER_SOCIAL, REMOVE_USER_SOCIAL,
} from "../types";
import { ActionType, InitialStateUserType } from '../../typings/state'

const initialState: InitialStateUserType = {
  authenticated: false,
  token: '',
  profile: undefined,
  social: undefined
};

export default function (state = initialState, action: ActionType) {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
      };
    case SET_UNAUTHENTICATED:
      return initialState;
    case SET_USER:
      return {
        authenticated: true,
        ...action.payload,
      };
    case SET_USER_SOCIAL:
      return {
        ...state,
        social: {...action.payload},
      };
    case REMOVE_USER_SOCIAL:
      return {
        ...state,
        social: undefined,
      };
    default:
      return state;
  }
}
